import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterOutlet } from '@angular/router';
import { FuseFullscreenComponent } from '@fuse/components/fullscreen';
import { FuseLoadingBarComponent } from '@fuse/components/loading-bar';
import { UserComponent } from 'app/layout/common/user/user.component';
import { TenantRouterService } from '../../../shared/services/tenant-router.service';
import { HelpMenuComponent } from '../../common/help-menu/help-menu.component';

@Component({
    selector: 'logged-in-single',
    templateUrl: './logged-in-single.component.html',
    imports: [
        FuseLoadingBarComponent,
        MatButtonModule,
        MatIconModule,
        MatTooltipModule,
        FuseFullscreenComponent,
        UserComponent,
        HelpMenuComponent,
        RouterOutlet,
    ],
})
export class LoggedInSingleComponent {
    private readonly tenantRouter = inject(TenantRouterService);

    protected get currentYear(): number {
        return new Date().getFullYear();
    }

    protected goBack(): void {
        this.tenantRouter.navigate(['prompts']);
    }
}
